export default {
  NOOK: 'Nook',
  GROW_PACKS: 'Grow Packs',
};
